import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const GeneralProductListing = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12700"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12700)">
          <rect
            x="-4"
            y="-3"
            width="123"
            height="115"
            rx="5.2028"
            fill="#ECFEFF"
          />
          <rect
            x="29.3707"
            y="37.3258"
            width="60.4284"
            height="36.1292"
            rx="2.80903"
            fill="white"
            stroke="#191919"
            strokeWidth="0.959181"
          />
          <path
            d="M85.9223 37.4857L30.1699 71.5047C30.1699 71.5047 30.5615 72.4349 31.2586 72.7707C31.9556 73.1065 32.901 73.2951 33.8867 73.2951H85.9223C86.9081 73.2951 87.8535 73.1065 88.5505 72.7707C89.2476 72.4349 89.6391 71.9795 89.6391 71.5047V39.2762C89.6391 38.8013 89.2476 38.3459 88.5505 38.0101C87.8535 37.6744 85.9223 37.4857 85.9223 37.4857Z"
            fill="#E3E3E3"
          />
          <path
            d="M44.0295 45.796H65.771"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.0295 50.729H72.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.0295 55.6621H65.771"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.0295 60.5948H72.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.0295 65.5277H72.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="29.3707"
            y="37.3258"
            width="60.4284"
            height="36.1292"
            rx="2.80903"
            stroke="#191919"
            strokeWidth="0.959181"
          />
          <path
            d="M15.2044 46.1914L16.7425 47.7295L21.8696 42.6024L20.3315 41.0643C19.6479 40.4025 18.7316 40.036 17.7802 40.0437C16.8287 40.0514 15.9185 40.4328 15.2457 41.1056C14.5729 41.7783 14.1916 42.6886 14.1838 43.64C14.1761 44.5914 14.5427 45.5078 15.2044 46.1914Z"
            fill="#FF808C"
          />
          <path
            d="M27.4683 58.4552L34.6462 60.506L32.5954 53.3281L27.4683 58.4552Z"
            fill="#FFBC44"
          />
          <path
            d="M21.8696 42.6046L32.5955 53.3305L27.4684 58.4576L16.7425 47.7317L21.8696 42.6046Z"
            fill="#FFEF5E"
          />
          <path
            d="M15.2044 46.1914L16.7425 47.7295L21.8696 42.6024L20.3315 41.0643C19.6479 40.4025 18.7316 40.036 17.7802 40.0437C16.8287 40.0514 15.9185 40.4328 15.2457 41.1056C14.5729 41.7783 14.1916 42.6886 14.1838 43.64C14.1761 44.5914 14.5427 45.5078 15.2044 46.1914Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.4683 58.4552L34.6462 60.506L32.5954 53.3281L27.4683 58.4552Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.8696 42.6046L32.5955 53.3305L27.4684 58.4576L16.7425 47.7317L21.8696 42.6046Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip0_1529_12700)">
            <path
              d="M91.8521 76.0024H78.0645C77.7592 76.0024 77.4618 75.9049 77.2158 75.724C76.9697 75.5431 76.788 75.2883 76.697 74.9968L75.2052 70.2217C75.1383 70.0073 75.1227 69.7802 75.1597 69.5586C75.1968 69.3371 75.2854 69.1274 75.4184 68.9464C75.5514 68.7654 75.7251 68.6183 75.9255 68.5168C76.1258 68.4153 76.3473 68.3624 76.5719 68.3623H92.9198C93.1266 68.363 93.3279 68.2959 93.4929 68.1713L92.6161 76.371C92.5291 76.2513 92.4138 76.155 92.2805 76.0907C92.1472 76.0264 92 75.996 91.8521 76.0024Z"
              fill="#C2F3FF"
            />
            <path
              d="M79.8714 73.2461C79.5663 73.246 79.2693 73.1485 79.0234 72.9678C78.7776 72.7871 78.5959 72.5326 78.5048 72.2415L77.2919 68.3622H76.5719C76.3473 68.3623 76.1258 68.4152 75.9255 68.5167C75.7251 68.6182 75.5514 68.7654 75.4184 68.9463C75.2854 69.1273 75.1968 69.337 75.1597 69.5586C75.1227 69.7801 75.1383 70.0072 75.2052 70.2216L76.697 74.9967C76.788 75.2882 76.9697 75.543 77.2158 75.7239C77.4618 75.9048 77.7592 76.0024 78.0645 76.0023H91.8521C92 75.996 92.1471 76.0264 92.2804 76.0907C92.4137 76.155 92.5291 76.2513 92.6162 76.371L92.9495 73.2461H79.8714Z"
              fill="#66E1FF"
            />
            <path
              d="M97.1047 64.5418H94.6618C94.5446 64.5409 94.4312 64.5831 94.3432 64.6604C94.2551 64.7377 94.1986 64.8447 94.1843 64.961L93.8672 67.5243C93.8386 67.7554 93.7265 67.9681 93.552 68.1223C93.3775 68.2766 93.1527 68.3617 92.9198 68.3618H76.5719C76.3473 68.362 76.1258 68.4149 75.9255 68.5164C75.7251 68.6178 75.5514 68.765 75.4184 68.946C75.2854 69.127 75.1968 69.3367 75.1597 69.5582C75.1227 69.7797 75.1383 70.0069 75.2052 70.2213L76.697 74.9963C76.788 75.2878 76.9697 75.5426 77.2158 75.7235C77.4618 75.9045 77.7592 76.002 78.0645 76.002H91.8521C92.1054 76.002 92.3483 76.1026 92.5274 76.2817C92.7065 76.4608 92.8072 76.7037 92.8072 76.957C92.8072 77.2103 92.7065 77.4532 92.5274 77.6323C92.3483 77.8114 92.1054 77.912 91.8521 77.912H78.4819"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M93.2856 70.272L92.8635 74.071"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M80.393 82.6876C80.7729 82.6876 81.1373 82.5366 81.4059 82.268C81.6746 81.9993 81.8255 81.635 81.8255 81.255C81.8255 80.8751 81.6746 80.5107 81.4059 80.2421C81.1373 79.9734 80.7729 79.8225 80.393 79.8225C80.013 79.8225 79.6487 79.9734 79.38 80.2421C79.1114 80.5107 78.9604 80.8751 78.9604 81.255C78.9604 81.635 79.1114 81.9993 79.38 82.268C79.6487 82.5366 80.013 82.6876 80.393 82.6876Z"
              fill="#D7D7D7"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M90.8981 82.6876C91.278 82.6876 91.6424 82.5366 91.9111 82.268C92.1797 81.9993 92.3306 81.635 92.3306 81.255C92.3306 80.8751 92.1797 80.5107 91.9111 80.2421C91.6424 79.9734 91.278 79.8225 90.8981 79.8225C90.5182 79.8225 90.1538 79.9734 89.8852 80.2421C89.6165 80.5107 89.4656 80.8751 89.4656 81.255C89.4656 81.635 89.6165 81.9993 89.8852 82.268C90.1538 82.5366 90.5182 82.6876 90.8981 82.6876Z"
              fill="#D7D7D7"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12700">
            <rect
              width="23.6598"
              height="23.6598"
              fill="white"
              transform="translate(74.2922 61.7844)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
